import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import GoogleLogin from 'react-google-login'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import get from 'lodash.get'

import { css } from 'react-emotion'
import { ControlFeedback, FormGroup, Typography, Input as SmoothInput } from '@smooth-ui/core-em'
import { Input, Box, Button, Space } from 'UILibrary'

import Loader from '../../../components/Loader'
import pick from 'lodash.pick'
import { OAUTH_PROVIDERS, MESSAGE } from '../../../constants'
import { trackEvent } from 'utils'

import google from 'images/svg/google_btn.svg'
import facebook from 'images/svg/facebook_btn.svg'

const formFields = ['email', 'password']
const InputAsBoxDix = SmoothInput.withComponent('div')

const signUpLinkClass = css({
  textDecoration: 'none',
  color: '#00bcb5',
})
const socialBtn = css({
  cursor: 'pointer',
})

const forgotLinkClass = css({
  textDecoration: 'none',
  color: '#838383',
})

const iframeClass = css({
  border: 'none',
  width: '139px',
  height: '44px',
})

const iframeBtns = css({
  '@media (max-width: 767px)': {
    img: {
      width: '139px !important',
      height: '44px',
      '@media (max-width: 359px)': {
        margin: '0 3px 0 -9px',
      },
    },
  },
})

const signInText = css({
  padding: '10px',
  color: '#838383',
  fontSize: '14px',
})

class SignIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      googleLoginDisabled: false,
      error: null,
      hideIframe: window.location.hostname === process.env.REACT_APP_BASE_DOMAINS,
    }
  }

  static defaultProps = {
    socialAuthenticate: () => {},
    authenticate: () => {},
    onAuthenticationSuccess: () => {},
    onSocialAuthNotCompleted: () => {},
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.id

    this.setState({
      [name]: target.value,
      error: null,
    })
  }

  componentDidMount() {
    !this.state.hideIframe && this.setFrameLoad()
  }

  setFrameLoad() {
    this.ifr.onload = () => {
      window.addEventListener('message', this.handleFrameTasks)
    }
  }

  responseFacebook = response => {
    const facebook_token = get(response, ['accessToken'], undefined)
    if (facebook_token) {
      this.handleSocialSignIn({ OAuthProvider: OAUTH_PROVIDERS.FACEBOOK, socialAuthToken: facebook_token })
    }
  }

  handleSocialSignIn = async normalizedResponse => {
    try {
      const response = await this.props.socialAuthenticate(normalizedResponse)

      if (response.token) {
        this.props.onAuthenticationSuccess()
      } else {
        this.props.onSocialAuthNotCompleted()
      }
    } catch (error) {
      this.props.onNonExpectedErrors(error, Error(MESSAGE.GOOGLE_ERROR))
    }
  }

  responseGoogle = response => {
    const google_token = get(response, ['tokenId'], undefined)
    if (google_token) {
      this.handleSocialSignIn({ OAuthProvider: OAUTH_PROVIDERS.GOOGLE, socialAuthToken: google_token })
    } else {
      this.props.onNonExpectedErrors(Error(MESSAGE.GOOGLE_ERROR))
    }
  }

  handleGoogleLoginFailure = ({ error, details }) => {
    console.log('Google Login Failure', error, details)

    if ('idpiframe_initialization_failed' === error) {
      this.setState({ googleLoginDisabled: true })
    }
  }

  isValid = userData => {
    return userData.password.length >= 8 && userData.email
  }

  handleSignIn = async event => {
    event.preventDefault()
    let userData = pick(this.state, formFields)

    if (!this.isValid(userData)) {
      this.setState({
        error: 'Invalid Email or Password',
      })
      return
    }
    try {
      userData.email = userData.email.toLowerCase()
      const response = await this.props.authenticate(userData)
      if (response.token) {
        trackEvent({ category: 'Login', action: 'Website login' })
        this.props.onAuthenticationSuccess()
      } else {
        this.props.onAuthenticationFailed(response)
      }
    } catch (error) {
      this.props.onNonExpectedErrors(error, Error('Some unexpected error ocurred'))
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks)
  }

  handleFrameTasks = e => {
    if (e.origin.indexOf(process.env.REACT_APP_BASE_DOMAINS) > -1) {
      if (e.data === 'error') {
        this.props.onNonExpectedErrors(Error(MESSAGE.GOOGLE_ERROR))
      } else {
        this.handleSocialSignIn({ OAuthProvider: OAUTH_PROVIDERS.GOOGLE, socialAuthToken: JSON.parse(e.data) })
        this.setState({ hideIframe: true })
      }
    }
  }

  render() {
    const canSingIn = this.state.email && this.state.password
    const { isLoading } = this.props
    // const port = window.location.hostname.indexOf('localhost') > -1 ? ':3000' : ''
    const frameUrl = window.location.protocol + '//' + process.env.REACT_APP_BASE_DOMAINS + '/googleLogin'
    return (
      <span>
        {this.props.title && (
          <span>
            <Typography variant="h3">{this.props.title}</Typography>
            <Space size="xl" />
          </span>
        )}
        <form onSubmit={this.handleSignIn} className={!this.state.hideIframe ? iframeBtns : ''}>
          <FormGroup>
            <Input
              control
              id="email"
              type="email"
              maxLength="80"
              valid={this.state.error ? false : null}
              placeholder="Enter Email"
              onChange={this.onFormFieldChange}
            />
          </FormGroup>
          <FormGroup>
            <InputAsBoxDix control p="0" valid={this.state.error ? false : null}>
              <Input width="80%" type="password" id="password" placeholder="Enter Password" onChange={this.onFormFieldChange} border="none" />
              <Link className={forgotLinkClass} to="/auth/forgot">
                Forgot?
              </Link>
            </InputAsBoxDix>
            {this.state.error && <ControlFeedback valid={false}>{this.state.error}</ControlFeedback>}
          </FormGroup>
          <Button form success onClick={this.handleSignIn} disabled={!canSingIn}>
            {isLoading ? <Loader color="white" /> : 'SIGN IN'}
          </Button>
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
            <Box height="1px" backgroundColor="#eaeaea" flex="1" />
            <p className={signInText}>Or Sign in with</p>
            <Box height="1px" backgroundColor="#eaeaea" flex="1" />
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            <FacebookLogin
              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
              autoLoad={false}
              callback={this.responseFacebook}
              disableMobileRedirect={true}
              render={renderProps => (
                <div className={socialBtn} onClick={renderProps.onClick}>
                  <img src={facebook} alt={'facebook'} />
                </div>
              )}
            />
            {!this.state.hideIframe ? (
              <iframe scrolling="no" title="googleLogin" ref={f => (this.ifr = f)} src={frameUrl} className={iframeClass} />
            ) : (
              <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                disabled={this.state.googleLoginDisabled}
                buttonText="Login"
                onSuccess={this.responseGoogle}
                onFailure={this.handleGoogleLoginFailure}
                render={renderProps => (
                  <div className={socialBtn} onClick={renderProps.onClick}>
                    <img src={google} alt={'google'} />
                  </div>
                )}
              />
            )}
          </Box>
          <Space size="l" />
          <Typography color="gray">Not a member yet?</Typography>
          <Space size="m" kind="inline" />
          <Typography color="success" fontWeight="bold">
            <Link className={signUpLinkClass} to="/auth/register?expanded=true">
              Sign Up as an Investor
            </Link>
          </Typography>
        </form>
      </span>
    )
  }
}

PropTypes.SignIn = {
  onAuthenticationSuccess: PropTypes.func.isRequired,
  onSocialAuthNotCompleted: PropTypes.func.isRequired,
  socialAuthenticate: PropTypes.func.isRequired,
  authenticate: PropTypes.func.isRequired,
  onNonExpectedErrors: PropTypes.func.isRequired,
  onAuthenticationFailed: PropTypes.func.isRequired,
}

export default SignIn



// WEBPACK FOOTER //
// ./src/features/authentication/components/SignIn.js